import { useLingui } from '@lingui/react/macro';

import Hide from '@rover/icons/svg/hide.svg';
import Secure from '@rover/icons/svg/secure.svg';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import { PRIVATE_BADGE_GLYPH_SIZE, PRIVATE_BADGE_SIZE } from './constants';

type Props = {
  isLocked?: boolean;
};

// Labelled rather than captioned: a text chip would cover the photo. Shaped
// after Kibble's tertiary Badge, which the icon-only `text` prop rules out.
const GalleryPrivateBadge = ({ isLocked = false }: Props): JSX.Element => {
  const { t } = useLingui();
  const theme = useTheme();
  const label = isLocked ? t`Locked photo` : t`Private photo`;
  const Glyph = isLocked ? Secure : Hide;

  return (
    <Flex
      testID={isLocked ? 'gallery-locked-badge' : 'gallery-private-badge'}
      width={PRIVATE_BADGE_SIZE}
      height={PRIVATE_BADGE_SIZE}
      borderRadius="secondary"
      background="tertiary"
      alignItems="center"
      justifyContent="center"
      webProps={{ role: 'img', 'aria-label': label }}
      rxnProps={{
        accessible: true,
        accessibilityRole: 'image',
        accessibilityLabel: label,
      }}
    >
      <Glyph
        width={PRIVATE_BADGE_GLYPH_SIZE}
        height={PRIVATE_BADGE_GLYPH_SIZE}
        fill={theme.textColor.secondary}
      />
    </Flex>
  );
};

export default GalleryPrivateBadge;
